import { FOLDER_DIRECTORIES } from '../../constants/folder';

export const foldersKeys = {
    all: ['folders'] as const,
    materialCountsByDirectory: (directory: FOLDER_DIRECTORIES) =>
        [...foldersKeys.all, directory, 'materialCounts'] as const,
    materialCounts: (directory: FOLDER_DIRECTORIES, folderIds: number[]) =>
        [...foldersKeys.materialCountsByDirectory(directory), [...folderIds].sort((a, b) => a - b)] as const
} as const;
